import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import './app/estilos/base.css';
import './app/estilos/pantallas.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Aplicacion } from './app/Aplicacion';

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <Aplicacion />
  </StrictMode>,
);
